import React, { useState } from 'react';
import { connect } from 'react-redux';

import '../Style/style.scss';
import image from '../Images/agents.jpg';

import validate from '../components/Form/validateInfo';
import useForm from '../components/Form/useForm';
import useTable from '../components/Footers/useTable';

import ZeneraContent from '../components/Content/ZeneraContent/ZeneraContent';
import Footer from '../components/Footers/Footer';
import ZeneraFooter from '../components/Footers/ZeneraFooter';

import Form from '../components/Form/Form';
import Common from '../components/Form/Common';
import Input from '../components/Form/Input';
import ButtonDarkBlue from '../components/Form/Button/ButtonDarkBlue';

import Sidebar from '../components/Sidebar';

const ZeneraPage = (props) => {
  const {mailBox, setMailBox} =  useTable();

  const {
    handleChange,
    handleSubmit,
    values,
    errors,
  } = useForm(submitForm, validate(props, false));

  const [isSubmitted, setIsSubmitted] = useState(false);
  function submitForm() {
    setIsSubmitted(true);
  }

  return (
    <div className='container'>
      <Sidebar/>

      <div className='content-left darkblue'>
        {/*if form is completed, show footer table with data*/}
        {!isSubmitted ? (
          <ZeneraContent />
        ) : (
          <Footer mailBox={mailBox} setMailBox={setMailBox}>
            <ZeneraFooter
              cName={values.cName}
              cAddress={values.cAddress}
              cStreet={values.cStreet}
              cNip={values.cNip}
              cMail={values.cMail}
              cPhone={values.cPhone}
            />
          </Footer>
        )}
      </div>

      <div className='content-right'>
        <img className='content-right--image' src={image} alt="meeting" />
        <Form handleSubmit={handleSubmit}>
          <Common errors={errors}/>
          <ButtonDarkBlue />
        </Form>
      </div>

    </div>
  );
};

// send props to validate
function mapStateToProps(state) {
  return {
    user_name: state.user_reducer.user_name,
    user_surname: state.user_reducer.user_surname,
    user_position: state.user_reducer.user_position,
    user_email: state.user_reducer.user_email,
    user_phone: state.user_reducer.user_phone,
  }
}
export default connect(mapStateToProps)(ZeneraPage);